exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loginscreen.middle-box{margin:0;width:100%;max-width:100%;flex-direction:column}.loginscreen.middle-box .center-login{margin:40px auto;padding:30px;width:95%;max-width:400px;box-sizing:border-box;background:#fff;box-shadow:0 16px 48px #e7ebf6}@media (min-width:600px){.loginscreen.middle-box{position:fixed;top:0;left:0;right:0;bottom:0;padding:0}.loginscreen.middle-box .center-login{padding:50px}}.center-login input{font-size:16px}.logo{max-width:100%}h3{margin:30px 0;color:#009ade;font-size:2em;padding:10px 0;text-align:left;border:dotted rgba(0,0,0,.1);border-width:1px 0}.btn-primary{background-color:#009ade}.btn-primary.active,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active,.btn-primary:active:focus,.btn-primary:active:hover,.btn-primary:focus,.btn-primary:hover,.open .dropdown-toggle.btn-primary{background-color:#0072a3;border-color:#009ade}a#forgotten-password-link{float:right}div#alternate-options{border-top:1px dotted rgba(0,0,0,.1);padding-top:15px}.left-text{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/userAccounts/login.component.css
// module id = 1259
// module chunks = 0